import { observer } from "mobx-react";
import { StaySomewhereElseToggleProps } from "components/flexComponents/WizardPackagePWA/typings";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkCheckbox } from "uitk-react-checkbox";
import * as React from "react";
import { locKeys } from "components/flexComponents/WizardPackagePWA/l10n";
import { useLocalization } from "@shared-ui/localization-context";

export const StaySomewhereElseToggle = observer(
  ({ colSpan, toggleStaySomewhereElse, packageWizardState }: StaySomewhereElseToggleProps) => {
    const { formatText } = useLocalization();

    return (
      <UitkLayoutGridItem colSpan={colSpan}>
        <div>
          <UitkCheckbox
            id="stay-somewhere-else-toggle"
            onChange={toggleStaySomewhereElse}
            checked={packageWizardState.staySomewhereElse}
          >
            {formatText(locKeys.staySomewhereElseToggleLabel)}
          </UitkCheckbox>
          <input
            type="hidden"
            name="isStaySomewhereElse"
            value={packageWizardState.staySomewhereElse ? 1 : 0}
            data-testid="stay-somewhere-else-input"
          />
        </div>
      </UitkLayoutGridItem>
    );
  }
);
